export const TASKS_ACTION_TYPE = {
	// REDUCER TYPES
	getAllTasks:'getAllTasks',
	TASKS_FETCHING_START: 'TASKS_FETCHING_START',
	TASKS: 'TASKS',
	CREATE_TASKS:'CREATE_TASKS',
	EDIT_TASK:'EDIT_TASK',
	CREATE_TASKS_IDLE:'CREATE_TASKS_IDLE'
};
